import * as Sentry from '@sentry/browser';

interface AjaxRefreshConfig {
    boxId: number;
    pageNode: string;
    buttonText: string;
    formatOfLoad: 'append' | 'replace' | 'default';
}

export const createAjaxRefresh = (config: AjaxRefreshConfig): void => {
    let currentPage = 2;
    let isLoading = false;
    
    const bindClickEvent = (button: HTMLAnchorElement) => {
        const handleClick = async (e: Event) => {
            e.preventDefault();
            if (isLoading) return;
            
            isLoading = true;
            const originalText = button.textContent;
            button.textContent = `Načítám ${config.buttonText}...`;
            button.classList.add('btn--loading');

            try {
                const url = `${location.pathname}?_sobfr=${config.boxId}&page=${currentPage}&ajaxload`;
                const response = await fetch(url, {
                    headers: { 'X-Requested-With': 'XMLHttpRequest' }
                });
                
                if (!response.ok) throw new Error('Network response was not ok');
                
                const html = await response.text();
                document.querySelector(`#pagingPlaceholder_${config.boxId}`)?.insertAdjacentHTML('beforebegin', html);

                // Remove duplicates
                const ids = new Set();
                document.querySelectorAll('[id]').forEach(el => {
                    if (!el.classList.contains('isport-premium-true') && 
                        !el.classList.contains('backbone-view')) {
                        if (ids.has(el.id)) {
                            el.remove();
                        } else {
                            ids.add(el.id);
                        }
                    }
                });

                currentPage++;
                
                // Get fresh button reference and rebind click
                const newButton = document.querySelector(`#load_${config.boxId} a`) as HTMLAnchorElement;
                if (newButton) {
                    newButton.href = `${location.pathname}?_sobfr=${config.boxId}&page=${currentPage}&ajaxload`;
                    bindClickEvent(newButton);
                }
                
            } catch (error) {
                Sentry.captureException(error);
            } finally {
                isLoading = false;
                button.classList.remove('btn--loading');
                button.textContent = originalText;
            }
        };

        button.removeEventListener('click', handleClick);
        button.addEventListener('click', handleClick);
    };

    // Initial binding
    const initialButton = document.querySelector(`#load_${config.boxId} a`) as HTMLAnchorElement;
    if (initialButton) {
        bindClickEvent(initialButton);
    }
};

window.createAjaxRefresh = createAjaxRefresh;